/* eslint-disable max-len */
import Vast from '../index';
import { isHttpUrl } from '../lib';
/*
* This method is responsible for rendering a nonlinear ad
*/
export function playCompanionAd(creative) {
  creative.variations.map((variation) => {
    const clickThrough = () => {
      if (isHttpUrl(variation.companionClickThroughURLTemplate)) {
        window.open(variation.companionClickThroughURLTemplate, '_blank');
      }
      this.companionVastTracker.click(null, this.macros);
    };
    const mount = (ressourceContainer) => {
      this.trackImpression(this.companionVastTracker, this.macros);
      const slot = variation.adSlotID && document.getElementById(variation.adSlotID);
      (slot || this.player.el()).appendChild(ressourceContainer);
    };

    // image
    if (variation.staticResources && variation.staticResources.length > 0) {
      variation.staticResources.map((staticResource) => {
        const ressourceContainer = document.createElement('div');
        this.domElements.push(ressourceContainer);
        ressourceContainer.width = variation.staticResources.width > 0 ? variation.staticResources.width : 100;
        ressourceContainer.height = variation.staticResources.height > 0 ? variation.staticResources.height : 100;
        ressourceContainer.style.maxWidth = variation.staticResources.expandedWidth;
        ressourceContainer.style.maxHeight = variation.staticResources.expandedHeight;
        Vast.applyNonLinearCommonDomStyle(ressourceContainer);

        const ressource = document.createElement('img');
        this.domElements.push(ressourceContainer);
        ressource.addEventListener('click', clickThrough);
        ressource.src = staticResource.url;
        ressourceContainer.appendChild(ressource);
        mount(ressourceContainer);
        return staticResource;
      });
    }

    // HTMLResources are not rendered: inserted as markup, the ad's scripts would run in this
    // page's origin.

    // iframe
    if (variation.iframeResources) {
      variation.iframeResources.filter(isHttpUrl).map((iframeResource) => {
        const ressourceContainer = document.createElement('div');
        this.domElements.push(ressourceContainer);
        ressourceContainer.width = variation.iframeResources.width;
        ressourceContainer.height = variation.iframeResources.height;
        ressourceContainer.style.maxWidth = variation.iframeResources.expandedWidth;
        ressourceContainer.style.maxHeight = variation.iframeResources.expandedHeight;
        Vast.applyNonLinearCommonDomStyle(ressourceContainer);
        ressourceContainer.addEventListener('click', clickThrough);
        ressourceContainer.src = iframeResource;
        mount(ressourceContainer);
        return iframeResource;
      });
    }
    return variation;
  });
}
